import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../services/AuthContext';
import { Unactive } from './unactive';

const ProtectedRoute = ({ children }) => {
  const { user, profile } = UserAuth();
  if (!user) {
    return <Navigate to='/signin' />;
  }
  if (!profile || !profile?.active) {
    return <Unactive></Unactive>
  }
  return children;
};

export default ProtectedRoute;